import {useTranslation} from "react-i18next";
import {DATE_TIME_FORMAT_NAME_MODEL, getDateFormat} from "../../../Apis/functions";

/**
 * @Email : kpozos@ibl.mx
 * @Author: Karen Yunuen Pozos Arias
 * @jobTittle: Full Stack Developer
 *
 * Details of one visit of the logged resident, the ones the invitations table
 * opens from the details action.
 *
 * The visit is the row of the table, the activity and the access points of the
 * invitation detail are left out until visitor-service exposes them.
 *
 * @param {Object} itemSelected - The visit currently selected to show details for.
 */
export const MyApartmentInvitationModalApp = ({itemSelected}) => {
    const { t } = useTranslation();

    // Status of the identity validation of the visitor, shown next to the title
    const identityValidationId = itemSelected?.identityValidation ?? null;

    // Zone the visitor enters through, the search returns the one of the
    // invitation and the root it hangs from
    const zoneName = itemSelected?.zoneName ?? '';
    const rootZoneName = itemSelected?.rootFatherZoneName ?? '';

    // Days the visit runs on, a visit that starts and ends the same day is
    // painted with that date alone instead of the range
    const startDate = getDateFormat(itemSelected?.startDate, false, DATE_TIME_FORMAT_NAME_MODEL.shortMonth);
    const endDate = getDateFormat(itemSelected?.endDate, false, DATE_TIME_FORMAT_NAME_MODEL.shortMonth);
    const isSameDate = startDate === endDate;

    return {
        t,
        identityValidationId,
        zoneName,
        rootZoneName,
        startDate,
        endDate,
        isSameDate
    }
}
